import advisoryImage from "../../../assets/Advisory.png";
import { EmptyState } from "../../../components/EmptyState"

interface SmartRecommendationProps {
  text?: string;
  emptyTitle?: string;
  emptyMessage?: string;
}

export function SmartRecommendation({
  text,
  emptyTitle,
  emptyMessage,
}: SmartRecommendationProps): JSX.Element {
  const isEmpty = !text

  return (
    <div className="rounded-xl border border-gray-200 bg-white p-4 sm:p-6">
      <h3 className="mb-4 text-base font-semibold text-gray-900">
        Smart Deployment Recommendation
      </h3>
      {isEmpty ? (
        <EmptyState
          variant="section"
          title={emptyTitle ?? 'No recommendation yet'}
          message={emptyMessage ?? "Once we've seen enough activity, smart deployment tips will appear here."}
        />
      ) : (
        <div className="flex flex-col items-center gap-4 sm:flex-row sm:items-start">
          <p className="flex-1 text-sm leading-relaxed text-gray-700">{text}</p>
          <div className="flex flex-col items-center gap-2 text-brand-green">
            <img src={advisoryImage} alt="Advisory" className="h-36 w-auto max-w-full sm:h-48" />
          </div>
        </div>
      )}
    </div>
  );
}
